import dayjs from 'dayjs';
import { MercuryEvents } from "../../services/types";
import { EventAutocompleteOption } from "../globalSettings/types";

export const filterEventsByEndDate = (eventEditions: MercuryEvents[] | EventAutocompleteOption[]): EventAutocompleteOption[] => {
  const currentDate = dayjs(new Date().getTime());
  return eventEditions.filter(event => {
    const eventDate = dayjs(event.endDate);
    const diff = currentDate.diff(eventDate, 'day');
    if (diff > 0) {
      const isProd = process.env.REACT_APP_ENVIRONMENT === 'production';
      return diff < (isProd ? 90 : 365);
    }
    return true;
  }) as EventAutocompleteOption[];
};
